var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import PropTypes from 'prop-types';
import { css, cx } from 'emotion';
import buildFlexProperties from './buildFlexProperties';
const FlexBox = (_a) => {
    var { className, children, isVertical, isInline, shouldWrap, noGrow, grow, shrink, basis, top, middle, bottom, left, center, right, spaceBetween, spaceAround, marginX, marginY, paddingX, paddingY } = _a, restProps = __rest(_a, ["className", "children", "isVertical", "isInline", "shouldWrap", "noGrow", "grow", "shrink", "basis", "top", "middle", "bottom", "left", "center", "right", "spaceBetween", "spaceAround", "marginX", "marginY", "paddingX", "paddingY"]);
    const flexProperties = { isVertical, top, middle, bottom, left, center, right, spaceBetween, spaceAround };
    const { justifyContent, alignItems } = buildFlexProperties(flexProperties);
    const layoutSizes = {
        xs: '0.25em',
        s: '0.5em',
        m: '0.75em',
        l: '1em',
        xl: '2em',
    };
    return (React.createElement("div", Object.assign({ className: cx(css `
        display: ${isInline ? 'inline-flex' : 'flex'};
        flex: ${noGrow ? '0 0 auto' : '1 1 auto'};
        flex-direction: ${flexProperties.isVertical ? 'column' : 'row'};
        flex-wrap: ${shouldWrap ? 'wrap' : 'nowrap'};
        justify-content: ${justifyContent};
        align-items: ${alignItems};
        padding: ${layoutSizes[paddingY] || 0} ${layoutSizes[paddingX] || 0};
        ${grow !== undefined && `flex-grow: ${grow};`}
        ${shrink !== undefined && `flex-shrink: ${shrink};`}
        ${basis !== undefined && `flex-basis: ${basis};`}
        /* The Below is used for giving flex children a gap similar to grid gap. Will only provide the gap if a marginY or X is provided */
        & > * + * {
          ${(flexProperties.isVertical && layoutSizes[marginY]) && `margin-top: ${layoutSizes[marginY]}`};
          ${(!flexProperties.isVertical && layoutSizes[marginX]) && `margin-left: ${layoutSizes[marginX]}`};
        }
      `, className) }, restProps), children));
};
FlexBox.defaultProps = {
    className: '',
};
FlexBox.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
    isVertical: PropTypes.bool,
    isInline: PropTypes.bool,
    noGrow: PropTypes.bool,
    shouldWrap: PropTypes.bool,
    grow: PropTypes.number,
    shrink: PropTypes.number,
    basis: PropTypes.oneOf([PropTypes.number, 'auto']),
    top: PropTypes.bool,
    middle: PropTypes.bool,
    bottom: PropTypes.bool,
    left: PropTypes.bool,
    center: PropTypes.bool,
    right: PropTypes.bool,
    spaceBetween: PropTypes.bool,
    spaceAround: PropTypes.bool,
    marginY: PropTypes.oneOf(['xs', 's', 'm', 'l', 'xl']),
    marginX: PropTypes.oneOf(['xs', 's', 'm', 'l', 'xl']),
    paddingX: PropTypes.oneOf(['xs', 's', 'm', 'l', 'xl']),
    paddingY: PropTypes.oneOf(['xs', 's', 'm', 'l', 'xl']),
};
export default FlexBox;
